import React, { ComponentProps, FC, forwardRef } from 'react';

import cn from '@/utils/cn';

import { Item, ItemText } from '@radix-ui/react-select';

const SelectItem: FC<ComponentProps<typeof Item>> = forwardRef(
  ({ children, ...props }, forwardedRef) => {
    return (
      <Item
        {...props}
        ref={forwardedRef}
        className={cn(
          'relative flex cursor-pointer select-none items-center rounded-lg px-2 py-[3px] outline-none',
          "data-[state='checked']:font-semibold hover:bg-gray-200 focus:bg-gray-200 focus:outline-none"
        )}
      >
        <ItemText asChild>
          <p className={cn('text-oxford-blue-500')}>{children}</p>
        </ItemText>
      </Item>
    );
  }
);

SelectItem.displayName = 'SelectItem';

export default SelectItem;
